import { useLayoutEffect } from "react";
import { useLocation } from "react-router";

import { routes } from "@/lib/routes";
import { appearanceStore } from "@/stores/appearance";

export const useDarkMode = () => {
  const { pathname } = useLocation();
  const isDarkMode = appearanceStore((state) => state.isDarkMode);
  const isSupportedRoute =
    routes.isDashboardRouteActive(pathname) ||
    routes.isMyAviaryRouteActive(pathname) ||
    routes.isLeaderboardRouteActive(pathname) ||
    routes.isCompaniesRouteActive(pathname) ||
    routes.isPlacementTrackerRouteActive(pathname) ||
    routes.isJobHealthRouteActive(pathname) ||
    routes.isPortfolioRouteActive(pathname) ||
    routes.isNotificationsRouteActive(pathname) ||
    routes.isEarningsRouteActive(pathname) ||
    routes.isToolsJobTrackerRouteActive(pathname) ||
    routes.isToolsExploreImagesRouteActive(pathname);

  // Apply at the document so portalled menus and candidate sheets share the palette.
  useLayoutEffect(() => {
    // Pet surfaces have their own illustrated palette, including portalled menus.
    const applyTheme = () => {
      const isPetSurfaceOpen = Boolean(
        document.querySelector("[data-pet-yard], [data-pet-shop]"),
      );
      const isEnabled = isDarkMode && isSupportedRoute && !isPetSurfaceOpen;
      document.documentElement.classList.toggle("dark", isEnabled);
      document.documentElement.classList.toggle("recruiter-dark", isEnabled);
    };
    applyTheme();
    const observer = new MutationObserver(applyTheme);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      document.documentElement.classList.remove("dark", "recruiter-dark");
    };
  }, [isDarkMode, isSupportedRoute]);
};
